
import hasPageMeta from '@/mixins/hasPageMeta'

export default {
    mixins: [hasPageMeta],

    async fetch() {
        await this.$axios.get(`/api/v1/public/users/${this.$route.params.username}`).then((res) => {
            this.model = res?.data?.data ? res.data.data : {}
        })
    },

    data() {
        return {
            model: {},
        }
    },

    computed: {
        avatarSrc() {
            if (this.model && this.model.avatar && this.model.avatar.url) return this.model.avatar.url
            if (this.model && this.model.cover && this.model.cover.url) return this.model.cover.url
            return require('~/assets/images/whimsical.png')
        },

        siteTitle() {
            return `${this.model.name} | Contributing Writer for Loverly`
        },
        siteDescription() {
            return `${this.model.expertise}`
        },

        previewImage() {
            return `${this.avatarSrc}`
        },
    },

    watch: {
        $route: '$fetch',
    },
}
